import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { message as antMessage } from 'ksnm-common-ui/lib/Message';
import type { ReactNode } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import { RoutePath } from '@components/AppRouter/constants';

const noGotoErrorPageMessage = [
  'Rendered more hooks than during the previous render.',
  'Rendered fewer hooks than expected.',
];

class ErrorBoundaryComponent extends Component<RouteComponentProps> {
  componentDidCatch({ message }: Error): void {
    // eslint-disable-next-line no-console
    console.log('custom error message:', message);
    // не менять страницу если это ошибка связанная с develop render
    const stopMessage = noGotoErrorPageMessage.find((f) => message.indexOf(f) >= 0);
    if (stopMessage) {
      antMessage.error(stopMessage);
      return;
    }
    this.props.history.replace(RoutePath.ERROR_PAGE);
  }

  render(): ReactNode {
    return this.props.children;
  }
}

export const ErrorBoundary = withRouter(ErrorBoundaryComponent);
